<template>
    <v-breadcrumbs icons divider="chevron_right" class="pl-4">
        <!-- exact=true to workaround https://github.com/vuetifyjs/vuetify/issues/1525 -->
        <v-breadcrumbs-item
            v-for="item in items" :key="item.id" :to="item.to" :exact="true"
        >
            {{ item.text }}
        </v-breadcrumbs-item>
    </v-breadcrumbs>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'main-breadcrumb',
        computed: {
            // eslint-disable-next-line
            ...mapState('nav', {
                items: state => state.breadcrumbItems,
            }),
        },
        methods: {},
    };
</script>

<style>
.breadcrumbs {
    justify-content: flex-start;
    padding: 0;
}

.breadcrumbs__item {
    font-size: x-large;
}

.breadcrumbs li:last-child a {
    color: black;
}

.breadcrumbs li:not(:last-child):after {
    font-size: x-large;
}
</style>



// WEBPACK FOOTER //
// MainBreadcrumb.vue?7d17e9db